import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';

const CaseViewContext = createContext();

export const useCaseViewContext = () => {
    const context = useContext(CaseViewContext);
    if (!context) {
        throw new Error("useCaseViewContext must be used within a CaseViewProvider");
    }
    return context;
}

export const CaseViewProvider = ({ children, value }) => {
    const [currentPharmacy, setCurrentPharmacy] = useState(value?.caseDetails?.pharmacy || null)
    const [currentPharmacyId, setCurrentPharmacyId] = useState(value?.caseDetails?.pharmacyId || null)
    const [chartingPrescriptions, setChartingPrescriptions] = useState({})
    
    useEffect(() => {
        const caseDetails = value?.caseDetails
        
        if (caseDetails) {
            if (caseDetails.status === 'rx change' && caseDetails.rxChangeRequest?.pharmacyId) {
                setCurrentPharmacyId(caseDetails.rxChangeRequest.pharmacyId)
            } else {
                if (caseDetails.pharmacy) {
                    setCurrentPharmacy(caseDetails.pharmacy)
                }
                if (caseDetails.pharmacyId) {
                    setCurrentPharmacyId(caseDetails.pharmacyId)
                }
            }
        }
    }, [value?.caseDetails])
    
    const updateCurrentPharmacy = useCallback((newPharmacy) => {
        setCurrentPharmacy(newPharmacy)
        setCurrentPharmacyId(newPharmacy?.pharmacyId || null)
    }, [])
    
    const enhancedValue = useMemo(() => ({
        ...value,
        currentPharmacy,
        currentPharmacyId,
        updateCurrentPharmacy,
        chartingPrescriptions,
        setChartingPrescriptions,
        apiClasses: value?.apiClasses,
        readOnlyMode: value?.readOnlyMode,
        apiType: value?.apiType,
        allowTagEditing: value?.allowTagEditing
    }), [
        value,
        currentPharmacy,
        currentPharmacyId,
        updateCurrentPharmacy,
        chartingPrescriptions,
    ])
    
    return (
        <CaseViewContext.Provider value={enhancedValue}>
            {children}
        </CaseViewContext.Provider>
    );
};
